'use strict';

/* global $ */

function Slider(options) {

    let opt = $.extend(true, {}, options);

    function initBlock(el) {
        let $el = $(el);
        if (!$(opt.asnavfor).length) { opt.asnavfor = null };

        if (opt.init) {
            $el.on('init', opt.init);
        }
        $el.slick({
            slidesToShow: opt.show,
            slidesToScroll: opt.scroll,
            centerMode: opt.centermode,
            appendArrows: opt.nav,
            prevArrow: $el.siblings().find(opt.prev),
            nextArrow: $el.siblings().find(opt.next),
            appendDots: opt.nav,
            dotsClass: opt.dotsClass,
            arrows: opt.arrows,
            dots: opt.dots,
            fade: opt.fade,
            infinite: opt.infinite,
            draggable: opt.drag,
            asNavFor: opt.asnavfor,
            variableWidth: opt.variablewidth,
            focusOnSelect: opt.focus,
            autoplay: opt.autoplay,
            autoplaySpeed: opt.autoplayspeed,
            adaptiveHeight: opt.adaptiveheight,
            slide: opt.slide,
            initialSlide: opt.initialslide,
            speed: opt.speed,
            rows: opt.rows,
            slidesPerRow: opt.perrow,
            responsive: opt.responsive,
            vertical: opt.vertical,
            verticalSwiping: opt.verticalswiping,
            lazyLoad: 'anticipated'
        });
        if (opt.before) {
            $el.on('beforeChange', opt.before);
        }
        if (opt.after) {
            $el.on('afterChange', opt.after);
        }
        if (opt.swipe) {
            $el.on('swipe', opt.swipe);
        }
        if (opt.externalnav) {
            if ($(opt.externalnav.length)) {
                $(opt.externalnav).eq(0).addClass('is-active');
                $(opt.externalnav).on('click', function(e){
                    e.preventDefault();
                    $(opt.externalnav).removeClass('is-active');
                    $(this).addClass('is-active');
                    let id = $(this).data('slider');
                    //console.log(id);
                    //let ind = $el.slick('getSlick').$slides.filter('[data-slider='+id+']').data('slider');
                    //console.log(ind);
                    //console.log($el.filter('[data-slider='+id+']'));
                    $el.slick('slickGoTo', id);
                });
                //$el.on('afterChange', function(event, slick, currentSlide) {
                //    $(opt.externalnav).removeClass('is-active');
                //    $(opt.externalnav).eq(currentSlide).addClass('is-active');
                //});
            }
        }
    }

    $(opt.selector).each(function() {
        initBlock(this);
    });
}

export {
    Slider
};
